import * as Sentry from '@sentry/react';

interface FeatureLogger {
  debug(msg: string, ctx?: Record<string, unknown>): void;
  info(msg: string, ctx?: Record<string, unknown>): void;
  warn(msg: string, ctx?: Record<string, unknown>): void;
  error(msg: string, err?: unknown, ctx?: Record<string, unknown>): void;
}

export function createFeatureLogger(feature: string): FeatureLogger {
  const isDev = import.meta.env.DEV;

  return {
    debug(msg: string, ctx?: Record<string, unknown>) {
      if (isDev) {
        console.debug(`[${feature}] ${msg}`, ctx ?? '');
      }
    },

    info(msg: string, ctx?: Record<string, unknown>) {
      console.info(`[${feature}] ${msg}`, ctx ?? '');
    },

    warn(msg: string, ctx?: Record<string, unknown>) {
      console.warn(`[${feature}] ${msg}`, ctx ?? '');
      Sentry.captureMessage(msg, { level: 'warning', extra: { feature, ...ctx } });
    },

    error(msg: string, err?: unknown, ctx?: Record<string, unknown>) {
      console.error(`[${feature}] ${msg}`, err);
      if (err instanceof Error) {
        Sentry.captureException(err, { extra: { feature, msg, ...ctx } });
      } else {
        Sentry.captureMessage(msg, { level: 'error', extra: { feature, err, ...ctx } });
      }
    },
  };
}
